export class UserToken{
    emailAddress: string;
    azureAccesToken: string;
}
export class TokenResponse{
    jwt_token: string;
    expires_in: Date;
}